module.exports = __webpack_public_path__ + "img/5.69c2ad26.jpg";